// Contact page entry. Wires the form to POST /api/contact, surfaces the
// real success/error feedback in the inline boxes, and resets the form
// after a successful submit.
import './site';
import { loadConfig } from '../envConfig';
import { setButtonBusy } from './lib/busy';
import { t } from './i18n/i18n';

void loadConfig();

const form         = document.getElementById('contact-form') as HTMLFormElement | null;
const errorBox     = document.getElementById('contact-error') as HTMLElement | null;
const successBox   = document.getElementById('contact-success') as HTMLElement | null;

// Deep-link support: /contact.html?topic=charging_card (e.g. the "request a
// charging card" CTA on the charging-points page) pre-selects the subject.
const presetTopic = new URL(window.location.href).searchParams.get('topic');
if (presetTopic) {
  const topicSelect = document.getElementById('cf-topic') as HTMLSelectElement | null;
  if (topicSelect && Array.from(topicSelect.options).some((o) => o.value === presetTopic)) {
    topicSelect.value = presetTopic;
  }
}

function showError(msg: string): void {
  if (!errorBox) return;
  errorBox.textContent = msg;
  errorBox.hidden = false;
  errorBox.classList.add('is-shown');
}
function clearError(): void {
  if (!errorBox) return;
  errorBox.textContent = '';
  errorBox.hidden = true;
  errorBox.classList.remove('is-shown');
}
function showSuccess(msg: string): void {
  if (!successBox) return;
  successBox.textContent = msg;
  successBox.hidden = false;
}
function clearSuccess(): void {
  if (!successBox) return;
  successBox.textContent = '';
  successBox.hidden = true;
}

form?.addEventListener('submit', async (event) => {
  event.preventDefault();
  clearError();
  clearSuccess();

  const data = new FormData(form);
  const payload = {
    name:         String(data.get('name') ?? '').trim(),
    email:        String(data.get('email') ?? '').trim(),
    organisation: String(data.get('organisation') ?? '').trim() || null,
    phone:        String(data.get('phone') ?? '').trim() || null,
    topic:        String(data.get('topic') ?? '').trim(),
    message:      String(data.get('message') ?? '').trim(),
  };

  if (!payload.name || !payload.email || !payload.topic || payload.message.length < 10) {
    showError(t('contact.form.err_validation'));
    return;
  }

  const submitBtn = form.querySelector<HTMLButtonElement>('button[type="submit"]');
  setButtonBusy(submitBtn, true);
  try {
    const { default: axios } = await import('axios');
    await axios.post('/api/contact', payload);
    showSuccess(t('contact.form.success'));
    form.reset();
  } catch (err) {
    const status = (err as { response?: { status?: number } })?.response?.status;
    const msg    = (err as { response?: { data?: { message?: string } } })?.response?.data?.message;
    if (status === 429) {
      showError(t('contact.form.err_rate_limited'));
    } else {
      showError(msg ?? t('contact.form.err_submit'));
    }
  } finally {
    setButtonBusy(submitBtn, false);
  }
});
